import { render, staticRenderFns } from "./AccountMajorMedicalInsurance.vue?vue&type=template&id=fa04fe60&scoped=true&"
import script from "./AccountMajorMedicalInsurance.vue?vue&type=script&lang=js&"
export * from "./AccountMajorMedicalInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa04fe60",
  null
  
)

export default component.exports